import React, {FC} from 'react';
import loading from '../../assets/img/icon_loading.gif';
import styles from './LoadingIcon.module.css';

export const LoadingIcon: FC = () => {
    return (
        <div className={styles.loading}>
            <img src={loading} alt="読込中" />
        </div>
    );
};
